{
  "modal": {
    "close": "Close"
  },
  "toast": {
    "favoritesAdd": "Favorite added to your list",
    "favoritesRemove": "Favorite removed to your list",
    "programAdd": "Added to your program",
    "programRemove": "Removed from you program",
    "linkCopy": "Link copied",
    "linkCopyEmpty": "There is nothing to copy",
    "linkCopyError": "Unfortunately, an error occurred. Your browser does not support it."
  },
  "bookMeetings": {
    "placeholderDay": "Select day",
    "placeholderTime": "Select time",
    "placeholderNoAvailibleTimes": "No available times. Please choose another day"
  },
  "choicesJs": {
    "loadingText": "Loading...",
    "noResultsText": "No results found",
    "noChoicesText": "No choices to choose from",
    "itemSelectText": "Press to select",
    "uniqueItemText": "Only unique values can be added",
    "customAddItemText": "Only values matching specific conditions can be added",
    "addItemText": "Press Enter to add <b>$</b>",
    "maxItemText": "Only $ values can be added",
    "searchPlaceholderValue": "Enter a value to search"
  }
}
